//
//  CsvExportButton.tsx
//
//  isana.net,inc. Proprietary and Confidential
//

import Button from "@mui/material/Button";
import useCsvExport from "../hooks/useCsvExport";
import { CsvType } from "../constants/csv";
import { CsvExportCommonProps } from "../hooks/useCsvExportButton";
import { IntradayIntervalMinutes } from "../utils/env";

type CsvExportButtonProps = CsvExportCommonProps & {
  csvType: CsvType;
  disabled?: boolean;
};

const generateButtonLabel = (csvType: CsvType): string => {
  switch (csvType) {
    case CsvType.Azm: 
      return `${IntradayIntervalMinutes}分ごとのAZMデータをリクエスト`;

    case CsvType.HeartRate:
      return `${IntradayIntervalMinutes}分ごとの心拍数データをリクエスト`;

    case CsvType.Sleep:
      return "睡眠レベルごとの開始/終了時間データをリクエスト";

    case CsvType.Calories:
      return `${IntradayIntervalMinutes}分ごとの消費カロリーデータをリクエスト`;

    case CsvType.AutonomicNervousSystem:
      return "5分ごとのHRVデータをリクエスト";

    case CsvType.Summary:
      return "日次データをリクエスト";

    case CsvType.Spo2:
      return `Spo2データをリクエスト`;

    default:
      return "エクスポート";
  }
};

export const CsvExportButton: React.FC<CsvExportButtonProps> = ({
  showMessage,
  csvType,
  startDate,
  endDate,
  summaryItemIds,
  disabled = false,
}) => {
  const { handleCsvExport } = useCsvExport(showMessage);

  return (
    <Button
      key={csvType}
      variant="contained"
      color="primary"
      onClick={() =>
        handleCsvExport(csvType, startDate, endDate, summaryItemIds)
      }
      sx={{ width: 500, minWidth: 0, textTransform: "none"}}
      disabled={disabled}
    >
      {generateButtonLabel(csvType)}
    </Button>
  );
};
